import React from 'react';

const DeletedFilled = ({ disabled = false, width = 80, height = 80, color = '#545454', ...props }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 80 80'
			fill='none'
			{...props}
		>
			<path
				d='M10.0002 20.0002H70.0002M63.3336 20.0002V66.6669C63.3336 70.0002 60.0002 73.3335 56.6669 73.3335H23.3336C20.0002 73.3335 16.6669 70.0002 16.6669 66.6669V20.0002M26.6669 20.0002V13.3335C26.6669 10.0002 30.0002 6.66687 33.3336 6.66687H46.6669C50.0002 6.66687 53.3336 10.0002 53.3336 13.3335V20.0002M33.3336 36.6669V56.6669M46.6669 36.6669V56.6669'
				stroke={disabled ? '#0004' : color}
				stroke-width='6.67'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export default DeletedFilled;
